import { createSelector } from "@ngrx/store";
import { IStore } from "../store";

export const getMerchantState = createSelector(
    (store: IStore) => store.merchant,
    store => store,
);
